export const SPEED = 100;
export const FRAME_RATE = 10;
